export default __webpack_public_path__ + "static/media/lycianqueen7.260bb9c5.jpg";